// extracted by mini-css-extract-plugin
module.exports = {"boardWrapper":"Projects_boardWrapper__3T_sG","boardBody":"Projects_boardBody__2NM8t"};